import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    Grid,
    styled,
    Typography,
    Paper,
    Avatar,
    Hidden,
    Button,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Stack,
} from '@mui/material';
import Grow from '@mui/material/Grow';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import teacherImage2 from '../assets/teacher2.jpg';
import airTeachrLogo from '../assets/airTeachr-New-White-Logo.png';
import backgroundCircles from '../assets/BG-Join-Clients.png';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import LockOpenRoundedIcon from '@mui/icons-material/LockOpenRounded';
import SystemUpdateIcon from '@mui/icons-material/SystemUpdate';
import GetAppIcon from '@mui/icons-material/GetApp';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import theme from '../muiTheme';
import { gtag } from 'ga-gtag';
import { CenterFocusStrong } from '@mui/icons-material';

const StyledBox = styled(Box)(({ theme }) => ({
    padding: '0px 14px 14px 14px',
    height: '80%',
    textAlign: 'center',
    position: 'relative',
}));

// const MobileTypography = styled(Typography)(({ theme }) => ({
//     [theme.breakpoints.down('sm')]: {
//         textAlign: 'center',
//     },
// }));

const Image = styled('img')(({ theme }) => ({
    width: '100%',
    borderRadius: '10px',
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: '1rem',
    margin: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover, &:focus': {
        cursor: 'pointer',
        boxShadow:
            '0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12)',
    },
    [theme.breakpoints.down('sm')]: {
        margin: '2rem .3rem',
    },
    [theme.breakpoints.up('sm')]: {
        maxWidth: '35rem',
        margin: '2rem auto',
    },
}));

const StyledCircle = styled(Paper)(({ theme }) => ({
    margin: '2rem',
    height: '75px',
    width: '75px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '50%',
    justifyContent: 'space-between',
    '&:hover, &:focus': {
        cursor: 'pointer',
        boxShadow:
            '0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12)',
    },
    alignItems: 'center',
    justifyContent: 'center',
}));

const Root = () => {
    // let history = useHistory();

    const [redirectToHome, setRedirectToHome] = useState(false);
    const [signup, setSignup] = useState(false);
    const [showDownload, setShowDownload] = useState(false);
    const [installPrompt, setInstallPrompt] = useState(null);
    const [selected, setSelected] = useState(0);

    useEffect(() => {
        window.addEventListener('beforeinstallprompt', event => {
            // Prevent the browser from displaying its own install UI.
            event.preventDefault();

            // Get a reference to the install prompt object.
            setInstallPrompt(event);
            setShowDownload(true);
        });
    }, []);

    const downloadApp = () => {
        // Show the user a prompt to install your PWA.
        console.log('prompt to be shown');
        installPrompt.prompt();
    };

    useEffect(() => {
        if (isAuthenticated) {
            setRedirectToHome(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        window.location.hash === '#signup' ? setSignup(true) : setSignup(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.hash]);

    const { isAuthenticated, loginWithRedirect } = useAuth0();

    const handleChange = () => {
        setSignup(prev => !prev);
    };

    return (
        <div style={{ height: '100vh' }}>
            {redirectToHome ? (
                <Redirect to="Home"></Redirect>
            ) : (
                <Grid
                    container
                    directon="row"
                    justifyContent="space-around"
                    alignItems="center"
                    sx={{
                        backgroundColor: 'rgba(0,0,0,0)',
                        backgroundImage:
                            'linear-gradient(130deg, #4632da 0%, #06d9fa 89%) ',
                        minHeight: '100vh',

                        '&::before': {
                            content: "''",
                            position: 'absolute',
                            opacity: '0.15',
                            width: '100%',
                            height: '100vh',
                            backgroundOverlay: '',
                            backgroundImage: `url(${
                                process.env.PUBLIC_URL + backgroundCircles
                            })`,
                            backgroundPosition: 'center center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        },
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                            height: '100%',
                            minHeight: '100vh',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            width: '100%',
                        }}
                    >
                        <Box
                            sx={{
                                height: '80px',
                                margin: '2rem',
                                [theme.breakpoints.down('700')]: {
                                    textAlign: 'center',
                                },
                            }}
                        >
                            <Image
                                src={airTeachrLogo}
                                sx={{
                                    maxWidth: '16em',
                                }}
                                alt="airTeachr Logo"
                            ></Image>
                        </Box>
                        <StyledBox>
                            <Typography
                                variant="h1"
                                sx={{
                                    color: '#ffffff',
                                }}
                            >
                                Welcome
                            </Typography>
                            <Box sx={{ textAlign: 'center', width: '100%' }}>
                                <Typography
                                    variant="h2"
                                    style={{
                                        m: '8px auto',
                                        color: '#ffffff',
                                        fontSize: '16px',
                                    }}
                                >
                                    Please choose an option below to proceed
                                </Typography>
                                {signup && (
                                    <div>
                                        <Grow
                                            in={signup}
                                            {...(signup
                                                ? { timeout: 500 }
                                                : { timeout: 300 })}
                                        >
                                            <StyledPaper
                                                elevation={3}
                                                onClick={async () => {
                                                    await gtag(
                                                        'event',
                                                        'conversion',
                                                        {
                                                            'send_to':
                                                                'AW-11074738954/t2MACK658ogYEIq27KAp',
                                                            'event_callback':
                                                                window.location,
                                                        }
                                                    );
                                                    await loginWithRedirect({
                                                        scope: `${process.env.REACT_APP_scope} teacherProfile`,
                                                        display: 'popup',
                                                        screen_hint: 'signup',
                                                        redirectUri: `${process.env.REACT_APP_hostUrl}`,
                                                        appState: {
                                                            'type': 'teacher',
                                                            'returnTo':
                                                                '/home?type=teacher',
                                                        },
                                                    });
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Avatar
                                                        variant="rounded"
                                                        sx={{
                                                            width: '50px',
                                                            height: '50px',
                                                            backgroundColor:
                                                                '#4632da',
                                                        }}
                                                    >
                                                        <PeopleAltRoundedIcon fontSize="large" />
                                                    </Avatar>

                                                    <Box
                                                        sx={{
                                                            textAlign: 'left',
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                marginLeft:
                                                                    '1rem',
                                                            }}
                                                        >
                                                            Sign up as Teacher
                                                        </Typography>

                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                margin: '4px 0rem 0rem 1rem',
                                                            }}
                                                        >
                                                            Join the airTeachr
                                                            platform as a Casual
                                                            Relief Teacher
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                <Hidden only={['xs']}>
                                                    <KeyboardBackspaceOutlinedIcon
                                                        sx={{
                                                            rotate: '180deg',
                                                            color: '#4632da',
                                                        }}
                                                    />
                                                </Hidden>
                                            </StyledPaper>
                                        </Grow>
                                        <Grow
                                            in={signup}
                                            {...(signup
                                                ? { timeout: 1000 }
                                                : { timeout: 300 })}
                                        >
                                            <StyledPaper
                                                elevation={3}
                                                onClick={async () => {
                                                    await gtag(
                                                        'event',
                                                        'conversion',
                                                        {
                                                            'send_to':
                                                                'AW-11074738954/t2MACK658ogYEIq27KAp',
                                                            'event_callback':
                                                                window.location,
                                                        }
                                                    );
                                                    await loginWithRedirect({
                                                        scope: `${process.env.REACT_APP_scope} schoolProfile`,
                                                        display: 'popup',
                                                        screen_hint: 'signup',
                                                        redirectUri: `${process.env.REACT_APP_hostUrl}`,
                                                        appState: {
                                                            'type': 'school',
                                                            'returnTo':
                                                                '/home?type=school',
                                                        },
                                                    });
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Avatar
                                                        variant="rounded"
                                                        sx={{
                                                            width: '50px',
                                                            height: '50px',
                                                            backgroundColor:
                                                                '#4632da',
                                                        }}
                                                    >
                                                        <HomeWorkRoundedIcon fontSize="large" />
                                                    </Avatar>
                                                    <Box
                                                        sx={{
                                                            textAlign: 'left',
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                marginLeft:
                                                                    '1rem',
                                                            }}
                                                        >
                                                            Sign up as School
                                                        </Typography>

                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                margin: '4px 0rem 0rem 1rem',
                                                            }}
                                                        >
                                                            Add a new School to
                                                            the airTeachr
                                                            platform
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                <Hidden only={['xs']}>
                                                    <KeyboardBackspaceOutlinedIcon
                                                        sx={{
                                                            rotate: '180deg',
                                                            color: '#4632da',
                                                        }}
                                                    />
                                                </Hidden>
                                            </StyledPaper>
                                        </Grow>
                                        <Box>
                                            <Typography
                                                variant="span"
                                                sx={{ color: '#fff' }}
                                            >
                                                Already have an account?
                                                <a
                                                    href="#login"
                                                    onClick={handleChange}
                                                    style={{
                                                        color: '#6610f2',
                                                        paddingLeft: '5px',
                                                    }}
                                                >
                                                    Login
                                                </a>
                                            </Typography>
                                        </Box>
                                    </div>
                                )}
                                {!signup && (
                                    <Grow
                                        in={!signup}
                                        {...(!signup
                                            ? { timeout: 501 }
                                            : { timeout: 301 })}
                                    >
                                        <div>
                                            <StyledPaper
                                                elevation={3}
                                                onClick={() =>
                                                    loginWithRedirect()
                                                }
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Avatar
                                                        variant="rounded"
                                                        sx={{
                                                            width: '50px',
                                                            height: '50px',
                                                            backgroundColor:
                                                                '#4632da',
                                                        }}
                                                    >
                                                        <LockOpenRoundedIcon fontSize="large" />
                                                    </Avatar>
                                                    <Box
                                                        sx={{
                                                            textAlign: 'left',
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                marginLeft:
                                                                    '1rem',
                                                            }}
                                                        >
                                                            Login
                                                        </Typography>

                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                margin: '4px 0rem 0rem 1rem',
                                                            }}
                                                        >
                                                            Login to the
                                                            airTeachr platform
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                <Hidden only={['xs']}>
                                                    <KeyboardBackspaceOutlinedIcon
                                                        sx={{
                                                            rotate: '180deg',
                                                            color: '#4632da',
                                                        }}
                                                    />
                                                </Hidden>
                                            </StyledPaper>
                                            <Box>
                                                <Typography
                                                    variant="span"
                                                    sx={{ color: '#fff' }}
                                                >
                                                    Not registered with
                                                    airTeachr yet?
                                                    <a
                                                        href="#signup"
                                                        onClick={handleChange}
                                                        style={{
                                                            color: '#6610f2',
                                                            paddingLeft: '5px',
                                                        }}
                                                    >
                                                        Signup
                                                    </a>
                                                </Typography>
                                            </Box>
                                        </div>
                                    </Grow>
                                )}
                            </Box>
                            {/* <Typography
                                variant="h5"
                                sx={{ color: '#FFF', marginTop: '48px' }}
                            >
                                Install the airTeachr App
                            </Typography> */}
                            {/* {showDownload ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <StyledPaper
                                        elevation={3}
                                        sx={{
                                            width: '80px',
                                            height: '80px',
                                            textAlign: 'center',
                                            borderRadius: '50%',
                                            justifyContent: 'center',
                                        }}
                                        onClick={downloadApp}
                                    >
                                        <GetAppIcon
                                            sx={{
                                                color: '#4632da',
                                                fontSize: '56px',
                                            }}
                                        />
                                    </StyledPaper>
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginTop: '8px',
                                    }}
                                >
                                    <Grid container>
                                        <Grid
                                            container
                                            sx={{ justifyContent: 'center' }}
                                        >
                                            <Grid direction="row">
                                                <StyledCircle
                                                    sx={{
                                                        backgroundColor:
                                                            selected === 1
                                                                ? '#4c47d2'
                                                                : 'white',
                                                        color:
                                                            selected === 1
                                                                ? '#FFF'
                                                                : 'black',
                                                    }}
                                                    onClick={() =>
                                                        setSelected(1)
                                                    }
                                                >
                                                    <AppleIcon
                                                        sx={{
                                                            fontSize: '34px',
                                                        }}
                                                    ></AppleIcon>
                                                </StyledCircle>
                                            </Grid>
                                            <Grid item direction="row">
                                                <StyledCircle
                                                    sx={{
                                                        backgroundColor:
                                                            selected === 2
                                                                ? '#4c47d2'
                                                                : 'white',
                                                        color:
                                                            selected === 2
                                                                ? '#FFF'
                                                                : 'black',
                                                    }}
                                                    onClick={() =>
                                                        setSelected(2)
                                                    }
                                                >
                                                    <AndroidIcon
                                                        sx={{
                                                            fontSize: '34px',
                                                        }}
                                                    ></AndroidIcon>
                                                </StyledCircle>
                                            </Grid>
                                            <Grid item direction="row">
                                                <StyledCircle
                                                    sx={{
                                                        backgroundColor:
                                                            selected === 3
                                                                ? '#4c47d2'
                                                                : 'white',
                                                        color:
                                                            selected === 3
                                                                ? '#FFF'
                                                                : 'black',
                                                    }}
                                                    onClick={() =>
                                                        setSelected(3)
                                                    }
                                                >
                                                    <LaptopMacIcon
                                                        sx={{
                                                            fontSize: '34px',
                                                        }}
                                                    ></LaptopMacIcon>
                                                </StyledCircle>
                                            </Grid>
                                        </Grid>
                                        {selected > 0 && (
                                            <Grid item xs={12}>
                                                <StyledPaper
                                                    sx={{
                                                        justifyContent:
                                                            'center',
                                                    }}
                                                >
                                                    {selected === 1 ? (
                                                        <div>
                                                            <Typography
                                                                textAlign="center"
                                                                sx={{
                                                                    marginBottom:
                                                                        '12px',
                                                                }}
                                                                variant="h5"
                                                            >
                                                                iOS app download
                                                            </Typography>
                                                            <Typography variant="body1">
                                                                First, navigate
                                                                to{' '}
                                                                <a href="https://app.airTeachr.com.au">
                                                                    https://app.airTeachr.com.au
                                                                </a>{' '}
                                                                in Safari.{' '}
                                                                <br />
                                                                Press the
                                                                "Share" button
                                                                and select "Add
                                                                to Home Screen"
                                                                from the popup.
                                                                <br />
                                                                Lastly, tap
                                                                "Add" in the top
                                                                right corner to
                                                                finish
                                                                installing the
                                                                App.
                                                            </Typography>
                                                        </div>
                                                    ) : selected === 2 ? (
                                                        <div>
                                                            <Typography
                                                                textAlign="center"
                                                                sx={{
                                                                    marginBottom:
                                                                        '12px',
                                                                }}
                                                                variant="h5"
                                                            >
                                                                Andriod app
                                                                download
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                sx={{
                                                                    textAlign:
                                                                        'center',
                                                                }}
                                                            >
                                                                First, navigate
                                                                to the{' '}
                                                                <a href="https://app.airTeachr.com.au">
                                                                    https://app.airTeachr.com.au
                                                                </a>{' '}
                                                                in Chrome.{' '}
                                                                <br />A message
                                                                prompt will ask
                                                                you to install
                                                                the app. <br />
                                                                Lastly, Click
                                                                install.
                                                            </Typography>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <Typography
                                                                textAlign="center"
                                                                sx={{
                                                                    marginBottom:
                                                                        '12px',
                                                                }}
                                                                variant="h5"
                                                            >
                                                                Desktop app
                                                                download
                                                            </Typography>
                                                            <Typography variant="body1">
                                                                First, navigate
                                                                to the{' '}
                                                                <a href="https://app.airTeachr.com.au">
                                                                    https://app.airTeachr.com.au
                                                                </a>{' '}
                                                                in Chrome.{' '}
                                                                <br />A message
                                                                prompt will ask
                                                                you to install
                                                                the app. <br />
                                                                Lastly, Click
                                                                install.
                                                            </Typography>
                                                        </div>
                                                    )}
                                                </StyledPaper>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>
                            )
                            } */}
                        </StyledBox>
                    </Grid>
                    <Grid item md={6}>
                        <Hidden only={['xs', 'sm']}>
                            {' '}
                            <Box
                                align="center"
                                justify="center"
                                sx={{ maxWidth: '90%' }}
                            >
                                <Image
                                    src={teacherImage2}
                                    sx={{
                                        borderRadius: '300px 100px 100px 100px',
                                    }}
                                    alt="airTeachr is a platform for both schools and casual relief teachers"
                                ></Image>
                            </Box>
                        </Hidden>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

//This page is the location users are routed too when they log in
//It will detect if the user has a profile or not
//with no profile the user will be navigated to setUpProfile
//With a completed profile the user will be navigated to the Dashboard
export default Root;
